module.exports = __webpack_public_path__ + "static/img/04.0feb7f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index-mb/story/04.png
// module id = Ft1O
// module chunks = 1